import React, { useState } from 'react';
import ValidationTypes from '../../util/validationTypes';
import LoadButton from './LoadButton';
import useLoadingForm from '../../hooks/loadingFormHook';
import useLoading from '../../hooks/loadingHook';
import Username from '../../static/dashboard/username.svg';

import getCancelToken from '../../util/axios';
import axios from 'axios';
import '../../styles/dashboard/DashboardFollowers.css';

export default function DashboardFollowers({history}) {

    // This token is for interrupting the axios call when doing the follow operation.
    const [cancelFollowToken, setCancelFollowToken] = useState(getCancelToken());

    // The function that we wait for
    const submitFollowHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/1000", {
            cancelToken: cancelFollowToken.token
        });
    };

    const followFormRules = {
        username: [ValidationTypes.requiredString]
    };

    const { formData, handleChange, handleSubmit, errorMapping, ...loadingForm } = useLoadingForm({
        username: ''
    }, submitFollowHandler, null, null, followFormRules); // loadingForm includes 'loading' and 'loaded'


    const submitNoUnfollowHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500");
    }

    const noUnfollowFormRules = {
        noUnfollow: [
            {
                test: (value) => !value.length || /^(@\w+)(\n@\w+)*\n?$/.test(value),
                errorMsg: "Invalid format"
            }
        ]
    };

    const { formData: noUnfollowFormData, handleChange: handleNoUnfollowChange, 
        handleSubmit: handleNoUnfollowSubmit, errorMapping: noUnfollowErrorMapping, ...noUnfollowLoadingForm } = useLoadingForm({
        noUnfollow: ''
    }, submitNoUnfollowHandler, null, null, noUnfollowFormRules, true);

    // Unfollow button loading hook
    const unfollowAsyncHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/1000");
    }

    const { loaded: unfollowLoaded, loading: unfollowLoading, handleLoad: handleUnfollowLoad } = useLoading(unfollowAsyncHandler);

    return (
        <div className="DashboardFollowers">
            <div className="header">
                <h1>Grow Following</h1>
                <p>Automatically follow + unfollow a shop's followers</p>
            </div> 
            <div className="content-split">
                <div className="follow-section">
                    <form 
                    className="formDashboard"
                    onSubmit={handleSubmit}>
                        <div className={`username ${errorMapping.username ? 'form-error-input' : ''}`}>
                            <div><img src={Username} alt="" /></div>
                            <input 
                            className="withIcon"
                            type="text"
                            name="username"
                            value={formData.username}
                            placeholder="sellername"
                            onChange={handleChange}
                            />
                        </div>
                        {errorMapping.username && <p className="form-error">{errorMapping.username}</p>}
                        <LoadButton 
                        loading={loadingForm.loading}
                        loaded={loadingForm.loaded}
                        defaultText="Follow This Shop's Followers"
                        loadingText="42/559 Followed"
                        loadedText="Followed All"
                        theme="black" /> 
                    </form>
                    <button 
                    className={loadingForm.loading ? "secondary-button" : "disabled-button"}
                    onClick={(e) => {
                        if (loadingForm.loading) {
                            cancelFollowToken.cancel();
                            setCancelFollowToken(getCancelToken()); // Need a new cancel token on each new axios call.
                        }
                    }}>Stop Following</button>

                    {/* Need to check whether the user is actually following people for the specified username, otherwise 
                    this should be disabled!*/}
                    <LoadButton 
                    loading={unfollowLoading}
                    loaded={unfollowLoaded}
                    defaultText="Unfollow All Following"
                    loadingText="Unfollowing All"
                    loadedText="Unfollowed All"
                    classes="alert-button"
                    theme="white"
                    handleClick={handleUnfollowLoad} />
                </div>
                <div className="unfollow-section">
                    <h4>Don't unfollow these users</h4>
                    <form 
                    className="formDashboard"
                    onSubmit={handleNoUnfollowSubmit}>
                        <textarea 
                        className={noUnfollowErrorMapping.noUnfollow && 'form-error-input'}
                        name="noUnfollow"
                        placeholder="Enter one @name per line"
                        value={noUnfollowFormData.noUnfollow}
                        onChange={handleNoUnfollowChange} />
                        {noUnfollowErrorMapping.noUnfollow && <p className="form-error">{noUnfollowErrorMapping.noUnfollow}</p>}
                        <LoadButton 
                        disabled={!noUnfollowFormData.noUnfollow}
                        loading={noUnfollowLoadingForm.loading}
                        loaded={noUnfollowLoadingForm.loaded} 
                        defaultText="Save!"
                        loadingText="Saving"
                        loadedText="Saved"
                        classes="black"
                        theme="white"
                        />
                    </form>
                </div>
            </div>
            <p className="disclaimer">DISCLAIMER! Our app is pretty undetectable, 
                but take frequent breaks to ensure you aren’t flagged by Depop</p>
        </div>

    )
}